module.exports = __webpack_public_path__ + "static/media/smile@2x.8eb6ac25.png";